(function (window, document) {
  'use strict';
 
  if (window.PFMTrack) return; // already initialised
 
  var CONFIG = {
    cookieName: '_pfm_clk',
    cookieDays: 30,
    // First match wins. Add your tracker's param name here if it differs.
    clickParams: ['click_id', 'clickId', 'cid'],
    // cart attribute name  ->  URL query param
    passthrough: {
      _fbclid: 'fbclid',
      _ttclid: 'ttclid',
      _gclid: 'gclid',
      utm_source: 'utm_source',
      utm_medium: 'utm_medium',
      utm_campaign: 'utm_campaign',
      utm_content: 'utm_content',
      utm_term: 'utm_term',
      aff_source: 'source'
    },
    cartUpdateUrl: '/cart/update.js',
    syncGuardKey: '_pfm_synced',
    debugKey: '_pfm_debug'
  };
 
  var DEBUG = false;
  try {
    DEBUG =
      new URLSearchParams(window.location.search).get('pfm_debug') === '1' ||
      window.sessionStorage.getItem(CONFIG.debugKey) === '1';
    if (DEBUG) window.sessionStorage.setItem(CONFIG.debugKey, '1');
  } catch (e) {}
 
  function log() {
    if (!DEBUG || !window.console) return;
    var args = ['[pfm-track]'].concat(Array.prototype.slice.call(arguments));
    window.console.log.apply(window.console, args);
  }
 
  /* ---------------------------------------------------------------- cookie */
 
  function readCookie(name) {
    var parts = document.cookie ? document.cookie.split(';') : [];
    for (var i = 0; i < parts.length; i++) {
      var p = parts[i].trim();
      if (p.indexOf(name + '=') === 0) {
        try {
          return decodeURIComponent(p.substring(name.length + 1));
        } catch (e) {
          return null;
        }
      }
    }
    return null;
  }
 
  function writeCookie(name, value, days) {
    var secure = window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie =
      name +
      '=' +
      encodeURIComponent(value) +
      '; Max-Age=' +
      Math.floor(days * 86400) +
      '; Path=/; SameSite=Lax' +
      secure;
  }
 
  function deleteCookie(name) {
    document.cookie = name + '=; Max-Age=0; Path=/';
  }
 
  /* --------------------------------------------------------------- capture */
 
  function firstParam(qs, names) {
    for (var i = 0; i < names.length; i++) {
      var v = qs.get(names[i]);
      if (v) return v.trim();
    }
    return null;
  }
 
  /**
   * A fresh click_id in the URL always overwrites the stored one (last-touch)
   * and resets the timestamp. Returns the current payload, or null.
   */
  function capture() {
    var qs = new URLSearchParams(window.location.search);
    var incoming = firstParam(qs, CONFIG.clickParams);
 
    if (incoming) {
      var payload = {
        c: incoming,
        t: Date.now(),
        lp: window.location.pathname.slice(0, 120),
        x: {}
      };
      for (var attr in CONFIG.passthrough) {
        if (!Object.prototype.hasOwnProperty.call(CONFIG.passthrough, attr)) continue;
        var val = qs.get(CONFIG.passthrough[attr]);
        if (val) payload.x[attr] = val.trim().slice(0, 250);
      }
      writeCookie(CONFIG.cookieName, JSON.stringify(payload), CONFIG.cookieDays);
      clearSyncGuard(); // new value must be pushed to the cart
      log('captured', payload);
      return payload;
    }
 
    var raw = readCookie(CONFIG.cookieName);
    if (!raw) return null;
    try {
      var stored = JSON.parse(raw);
      return stored && stored.c ? stored : null;
    } catch (e) {
      log('malformed cookie, discarding');
      deleteCookie(CONFIG.cookieName);
      return null;
    }
  }
 
  /* ------------------------------------------------------------ cart sync */
 
  function buildAttributes(payload) {
    // Empty string removes an attribute. When the cookie is gone we must
    // actively clear, because Shopify carts persist ~14 days and can outlive it.
    var attrs = {
      _click_id: payload ? String(payload.c) : '',
      _click_ts: payload && payload.t ? String(payload.t) : '',
      _landing_page: payload && payload.lp ? String(payload.lp) : ''
    };
    for (var attr in CONFIG.passthrough) {
      if (!Object.prototype.hasOwnProperty.call(CONFIG.passthrough, attr)) continue;
      attrs[attr] = payload && payload.x && payload.x[attr] ? payload.x[attr] : '';
    }
    return attrs;
  }
 
  function syncGuardValue() {
    try {
      return window.sessionStorage.getItem(CONFIG.syncGuardKey);
    } catch (e) {
      return null;
    }
  }
 
  function setSyncGuard(v) {
    try {
      window.sessionStorage.setItem(CONFIG.syncGuardKey, v);
    } catch (e) {}
  }
 
  function clearSyncGuard() {
    try {
      window.sessionStorage.removeItem(CONFIG.syncGuardKey);
    } catch (e) {}
  }
 
  var inFlight = false;
 
  function pushToCart(payload, opts) {
    opts = opts || {};
    var attrs = buildAttributes(payload);
    var signature = attrs._click_id + '|' + attrs._click_ts;
 
    // Nothing stored and nothing was ever synced this session — no-op.
    if (!payload && !syncGuardValue()) return Promise.resolve(false);
 
    if (!opts.force && syncGuardValue() === signature) {
      log('already synced this session, skipping');
      return Promise.resolve(false);
    }
 
    if (inFlight) return Promise.resolve(false);
    inFlight = true;
 
    return nativeFetch(CONFIG.cartUpdateUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs }),
      keepalive: true,
      credentials: 'same-origin'
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart/update ' + res.status);
        setSyncGuard(signature);
        log('synced to cart', attrs);
        return true;
      })
      .catch(function (err) {
        log('sync failed, retrying once', err);
        return new Promise(function (resolve) {
          window.setTimeout(function () {
            nativeFetch(CONFIG.cartUpdateUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ attributes: attrs }),
              credentials: 'same-origin'
            })
              .then(function (res) {
                if (res.ok) setSyncGuard(signature);
                resolve(res.ok);
              })
              .catch(function () {
                resolve(false);
              });
          }, 1200);
        });
      })
      .then(function (result) {
        inFlight = false;
        return result;
      });
  }
 
  /* ------------------------------------------- re-assert after cart writes */
 
  // Keep a clean reference before anything else patches fetch.
  var nativeFetch = window.fetch.bind(window);
 
  var MUTATING = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
 
  function shouldReassert(url) {
    if (!url) return false;
    var s = String(url);
    // Our own writes must not trigger a loop.
    if (inFlight) return false;
    return MUTATING.test(s);
  }
 
  function reassertSoon() {
    window.setTimeout(function () {
      // /cart/clear.js drops attributes entirely, and third-party apps calling
      // /cart/update.js can clobber them. Force a re-push.
      pushToCart(capture(), { force: true });
    }, 300);
  }
 
  function patchFetch() {
    if (!window.fetch) return;
    var original = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : input && input.url;
      var method =
        (init && init.method) || (input && input.method) || 'GET';
      var isWrite = String(method).toUpperCase() === 'POST' && shouldReassert(url);
      var out = original.apply(this, arguments);
      if (isWrite && out && out.then) {
        out.then(function () {
          reassertSoon();
        }).catch(function () {});
      }
      return out;
    };
  }
 
  function patchXHR() {
    if (!window.XMLHttpRequest) return;
    var proto = window.XMLHttpRequest.prototype;
    var open = proto.open;
    var send = proto.send;
    proto.open = function (method, url) {
      this.__pfmWrite =
        String(method).toUpperCase() === 'POST' && shouldReassert(url);
      return open.apply(this, arguments);
    };
    proto.send = function () {
      var self = this;
      if (self.__pfmWrite) {
        self.addEventListener('load', function () {
          reassertSoon();
        });
      }
      return send.apply(this, arguments);
    };
  }
 
  /* ------------------------------------------------------------------ init */
 
  function init() {
    var payload = capture();
 
    // Skip cart writes inside the theme editor so previews don't pollute carts.
    var designMode = !!(window.Shopify && window.Shopify.designMode);
    if (designMode) {
      log('theme editor detected, capture only', payload);
      return;
    }
 
    pushToCart(payload);
 
    patchFetch();
    patchXHR();
 
    // Some themes swap URLs without a reload; re-check for a new click_id.
    window.addEventListener('popstate', function () {
      pushToCart(capture());
    });
  }
 
  window.PFMTrack = {
    /** Current stored payload, or null. */
    get: function () {
      return capture();
    },
    /** Force a re-push of attributes to the cart. */
    sync: function () {
      return pushToCart(capture(), { force: true });
    },
    /** Wipe the cookie and clear the cart attributes. */
    clear: function () {
      deleteCookie(CONFIG.cookieName);
      clearSyncGuard();
      return pushToCart(null, { force: true });
    },
    /** Dump current state and enable verbose logging for this session. */
    debug: function () {
      DEBUG = true;
      try {
        window.sessionStorage.setItem(CONFIG.debugKey, '1');
      } catch (e) {}
      var payload = capture();
      /* eslint-disable no-console */
      console.log('[pfm-track] cookie payload:', payload);
      console.log('[pfm-track] attributes:', buildAttributes(payload));
      console.log('[pfm-track] sync guard:', syncGuardValue());
      return nativeFetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          console.log('[pfm-track] live cart attributes:', cart.attributes);
          return cart.attributes;
        });
      /* eslint-enable no-console */
    },
    version: '1.0.0'
  };
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})(window, document);